@if (visible() && trial(); as running) {
    <div class="update-bar support-tier-trial" data-testid="topbar-support-tier-trial-banner">
        <span [innerHTML]="(running.cancelled ? 'navbar.support_tier_trial_cancelled' : 'navbar.support_tier_trial') | translate: { tier: running.label, end: running.end }"></span>
        <span> — </span>
        <a [routerLink]="['/account/support-tier']" data-testid="topbar-support-tier-trial-banner-details-link">{{ "navbar.support_tier_trial_details" | translate }}</a>
        <button class="banner-dismiss-btn" (click)="dismiss()" aria-label="Dismiss" data-testid="topbar-support-tier-trial-banner-dismiss-button">&#x2715;</button>
    </div>
}
